// Subsolar point [lng, lat] for a given time — the spot on Earth where the sun
// is directly overhead. Approximation (no external deps), good enough for a
// day/night terminator. lng is degrees east of Greenwich, lat is the solar
// declination.
export const sunPosAt = (date: Date): [number, number] => {
  const utcHours =
    date.getUTCHours() + date.getUTCMinutes() / 60 + date.getUTCSeconds() / 3600;
  const lng = -15 * (utcHours - 12);
  const start = Date.UTC(date.getUTCFullYear(), 0, 0);
  const dayOfYear = Math.floor((date.getTime() - start) / 86400000);
  const declination = -23.44 * Math.cos((2 * Math.PI / 365) * (dayOfYear + 10));
  return [lng, declination];
};
